import get from 'lodash/get'
import set from 'lodash/set'

import { HYDRATE_COMPLETION } from '@/store/modules/completion/types'

export default {
  data() {
    return {
      loaded: false,
      fetching: false
    }
  },
  computed: {
    userId() {
      return this.user.userInformations.userId
    },
    isLogged() {
      return this.user.userLogged
    },
    user() {
      return this.$store.state.user
    }
  },
  methods: {
    async hydrateCompletion() {
      // If the completion is empty and have not been fetched, fetch it
      if (!this.loaded && this.isLogged && !this.fetching) {
        this.fetching = true

        const completion = await this.$firestore.completion.getData(this.userId)
        delete completion.userId

        const completionState = this.unflatten(completion)

        this.$store.dispatch(HYDRATE_COMPLETION, { completionState })

        this.loaded = true
        this.fetching = false
      }
    },
    unflatten(data) {
      return Object.keys(data).reduce(
        (accumulator, property) => set(accumulator, property.split('.'), get(data, property)),
        {}
      )
    }
  },
  watch: {
    isLogged(value, prevValue) {
      if (!value && prevValue) {
        // User logged off, reset the loaded status
        this.loaded = false
      } else {
        // Force sync
        this.hydrateCompletion()
      }
    }
  }
}
